import { Table as AriaTable, type TableProps as AriaTableProps } from "react-aria-components";
import { tv } from "tailwind-variants";

import { cn } from "@/lib/helpers/cn";

type Table2Props = AriaTableProps;

export function Table2({ className, ...props }: Table2Props) {
  const { table } = styles();

  return <AriaTable className={cn(table(), className)} {...props} />;
}

const styles = tv({
  slots: {
    table: cn("tw:w-full tw:overflow-x-auto", "tw:border-separate tw:border-spacing-0"),
  },
});
